export default {
    required: 'Required field'
};
